import { Outlet } from "react-router-dom";

const Verificacion = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default Verificacion;
